import styled from 'styled-components'
import { useSegwayRouter } from '@/features/shared/hooks/useSegwayRouter'
import { ArrowLeftIcon } from '@shipt/design-system-icons'
import { isOnServer } from '@shared/constants/util'
import { TextButton } from '@shipt/design-system-buttons'
import { ClientOnly } from '@/features/shared/components/ClientOnly'
import { screenSizes } from '@shipt/design-system-themes'
import { Box } from '@shipt/design-system-layouts'

export const BackButton = ({
  backUrl,
  showLabel = false,
}: { backUrl?: string; showLabel?: boolean } = {}) => {
  const router = useSegwayRouter()
  const isPriorPage = !isOnServer() && window.history.length > 1

  return isPriorPage ? (
    // this is rendered on the client side due to using window.history, which is not available on the server.
    <ClientOnly>
      <Box padding={['md']} marginBottom={{ base: 'unset', lg: 'xl' }}>
        <Button
          $showLabel={showLabel}
          aria-label="Back"
          onClick={() => (backUrl ? router.replace(backUrl) : router.back())}
          leadingIcon={ArrowLeftIcon}
        >
          <span>Back</span>
        </Button>
      </Box>
    </ClientOnly>
  ) : null
}

const Button = styled(TextButton)<{ $showLabel: boolean }>`
  span {
    display: ${({ $showLabel }) => ($showLabel ? 'block' : 'none')};

    @media ${screenSizes.smDesktop} {
      display: block;
    }
  }
`
